// Single PostHog init module used by both surfaces:
//   - SPA   (frontend/src/main.jsx imports this for /admin/* + /login/*)
//   - Astro (frontend/landing/src/layouts/Base.astro inline <script>
//            imports this from the @/ alias, bundled into a tiny client
//            chunk that ships on every marketing + SEO page)
//
// VITE_POSTHOG_KEY is set in the dev / prod-go GitHub env, plumbed
// through Docker build args (see docker/frontend/Dockerfile) into
// import.meta.env at build time. If it's unset (local dev, preview
// builds), init() is a no-op so no broken events are sent.
//
// person_profiles: 'identified_only' so PostHog doesn't auto-create
// a row for every anonymous visitor — identified profiles only get
// created after GitHub OAuth completes and the SPA calls identify().

import posthog from 'posthog-js';

let initialized = false;

export function initPostHog() {
  if (initialized) return;
  if (typeof window === 'undefined') return;
  const key = import.meta.env.VITE_POSTHOG_KEY;
  if (!key) return;
  const host = import.meta.env.VITE_POSTHOG_HOST || 'https://eu.i.posthog.com';
  posthog.init(key, {
    api_host: host,
    person_profiles: 'identified_only',
    capture_pageview: true,
    capture_pageleave: true,
  });
  initialized = true;
}

export { posthog };
